import React from 'react';
import PropTypes from 'prop-types';
import OfferButton from './OfferButton';

const MtplOfferButton = ({
    client,
    vehicle,
    policyHolder,
}) => {
    return (
        <OfferButton client={client} vehicle={vehicle} policyHolder={policyHolder} link="/mtpl/new/find"
                     formName="mtplOfferForm" icon="car-alt" product="ГО" />);
};

MtplOfferButton.propTypes = {
    client: PropTypes.shape({
        personalNumber: PropTypes.string,
    }),
    vehicle: PropTypes.shape({
        plateNumber: PropTypes.string,
        registrationCertificateNumber: PropTypes.string,
    }),
    policyHolder: PropTypes.shape({
        personalNumber: PropTypes.string,
    }),
};

export default MtplOfferButton;
